var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"m-0"},[_c('b-col',{staticClass:"d-flex align-items-center px-2 p-lg-5"},[_c('login')],1),_c('b-col',{staticClass:"d-flex align-items-center px-2 p-lg-5"},[_c('b-card',[_c('register')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }